import { render, staticRenderFns } from "./SiteLogs.vue?vue&type=template&id=bf4944ba&scoped=true&"
import script from "./SiteLogs.vue?vue&type=script&lang=js&"
export * from "./SiteLogs.vue?vue&type=script&lang=js&"
import style0 from "./SiteLogs.vue?vue&type=style&index=0&id=bf4944ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4944ba",
  null
  
)

export default component.exports